export default __webpack_public_path__ + "static/media/sample_1.af116236.png";